import React, { Component } from "react";
import Modal from "../Modal/Modal";

class VotingErrorModal extends Component {
  render() {
    return (
      <Modal handleDismiss={this.props.handleDismiss}>
        <div className="voting-error-modal">
          <h3>You've already voted in this competition</h3>
          <p>
            We've already recorded votes from you in this competition. You can
            only vote once in a competition
          </p>
        </div>
      </Modal>
    );
  }
}

export default VotingErrorModal;



// WEBPACK FOOTER //
// ./src/components/VotingErrorModal/VotingErrorModal.js